<template>
  <div class="struct_analyse">
    <div class="top">
      <div class="top__img">
        <img src="https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/ana_icon.png" width="100%"/>
      </div>
      <div class="top__large">工程结构仿真</div>
      <div class="top__small" style="margin-top:20px;">采用大型通用有限元分析软件，结合自研专用分析模块，开展工程结构精细化仿真分析，为结构在设计、施工以及运营阶段所涉及的关键技术问题提供分析解决方案。</div>
    </div>
    <Breadcrumb style="margin: 20px 10%;font-size: 18px;">
      <BreadcrumbItem>首页</BreadcrumbItem>
      <BreadcrumbItem to="/business">业务介绍</BreadcrumbItem>
      <BreadcrumbItem>工程结构仿真</BreadcrumbItem>
    </Breadcrumb>
    <div class="content">
      <div v-for="item in structList" :key="item.id" class="contentBox">
        <!-- <div class="title">{{item.title}}</div> -->
        <img :src="item.image" alt="" width="100%">
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'struct_analyse',
  data() {
    return {
      projectList: [
        '广州市万龙跨海工程主桥抗震分析与试验研究',
        '韶关市江湾大桥结构分析',
        '汕头牛田洋快速通道工程抗震性能及减震措施研究',
        '高温堆反应堆压力容器承重支承处墙体结构施工及使用全寿期受力分析',
        '高温气冷堆核岛厂房结构抗震极限承载力评价研究',
        '虎门二桥悬索桥抗震与减震分析',
        '重庆市鹅公岩轨道专用桥工程抗震、结构仿真分析研究',
        '东莞滨海湾新区滨海湾大桥工程结构仿真分析',
        '佛山富龙西江特大桥工程结构仿真分析',
        '广州番禺大桥工程仿真分析',
        '黄茅海跨海通道工程主桥抗震与减震随机振动分析研究',
        '广州地铁东平站车致振动仿真分析'
      ],
      structList: [
        {
          id: 'struct1',
          title: '结构设计咨询',
          image: 'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/stru_simulation1.png'
        },
        {
          id: 'struct2',
          title: '结构设计咨询',
          image: 'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/stru_simulation2.png'
        },
        // {
        //   id: 'struct3',
        //   title: '结构设计咨询',
        //   image: 'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/stru_analyse3.png'
        // },
      ]
    }
  },
  created() {
    this.$emit('changeProduce','struct_analyse')
  },
  mounted () {
    document.body.scrollIntoView()
  }
}
</script>
<style lang="less" scoped>
.struct_analyse {
  .top {
    width: 100%;
    height: 280px;
    background: url('https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/stru_analyse_banner.png') center center no-repeat;
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    color: #fff;
    &__img {
      width: 67px;
      height: 68px;
    }
    &__large {
      margin-top: 16px;
      font-size: 24px;
      line-height: 1.5em;
    }
    &__small {
      font-size: 16px;
      line-height: 1.5em;
    }
  }
  .content {
    width: 1400px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-bottom: 64px;
    .contentBox{
      display: flex;
      flex-direction: column;
      align-items: center;
      margin: 20px 0;
      .title {
        margin: 48px 0 50px;
        position: relative;
        font-size: 30px;
        line-height: 1.5em;
        font-weight: bold;
        color: #000;
      }
      .title::after {
        content: "";
        position: absolute;
        bottom: -8px;
        left: 50%;
        transform: translateX(-50%);
        width: 50px;
        height: 8px;
        background-color: #FAAD14;
      }
      img{
        width: 100%;
        margin: 20px 0;
      }
    }
  }
}
</style>
